export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "No records",
    "notifications.rp_has_been_updated": "Gold Residential Project has been updated",
    "moduleTitle.files": "Files",
    "label.coordinator": "Coordinator",
    "sidebar.translations_managment": "",
    "table.file": "File",
    "label.report_overview": "",
    "label.parent_agreement": "Printable Parental Consent Form",
    "parentalConsent.i_consent_to_and_understand_that": "6. I consent to and understand that photographs may be taken of the participant participating in certain activities related to the Award and such photographs may be used for promotional purposes provided an appropriate release form has been signed by both the participant and their parent/guardian.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. I understand that participants are required to comply with the Award requirements contained in the Record Book or ORB, the policies and standards of behaviour of the relevant Award Operator (as amended from time to time) and requirements of the Award Centre in relation to emergency plans, assessment of activities and the conduct of Adventurous Journeys related to the Award, and understand that the Award Centre may withdraw its Authorisation to the participant’s participation in the Award if they do not comply.",
    "table.end_date": "End Date",
    "label.activation_date": "Activation Date",
    "label.report": "",
    "label.award_is_offline": "Award is offline",
    "label.pending_changes": "Pending changes...",
    "errors.min_nights_required": "A minimum of {nights} night(s) is required",
    "label.country": "Country",
    "notifications.award_leader_has_been_returned": "Award leader has been revised",
    "notifications.participant_has_been_updated": "Participant has been updated",
    "label.phone_number": "Phone Number",
    "roles.aj_assessor": "Adventurous Journey Assessor",
    "notifications.person_state_has_been_changed": "Person state has been changed",
    "pageTitle.dashboard": "Dashboard",
    "moduleTitle.global_payment_method": "Global payment method",
    "label.organization_type": "Organisation Type",
    "button.account_settings": "Account Settings",
    "notifications.contact_has_been_updated": "Contact has been updated",
    "participant.recover_password": "Recover Password",
    "notifications.assessment_request_has_been_sent": "Assessment request has been sent",
    "button.unassign": "",
    "label.start_date": "Start Date",
    "label.assign_labels": "",
    "sidebar.participants": "Participants",
    "roles.coordinator": "Coordinator",
    "label.organization_contact": "Organisation Contact",
    "tabs.customization": "Customisation",
    "sidebar.award_units": "Award Centres",
    "button.change_goal": "Change Goal",
    "translationsManagement.selectProject": "",
    "award.rp": "Gold Residential Project",
    "label.size": "Size",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "Activity has been Authorised",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Resend assessment request",
    "notifications.template_has_been_removed": "Template has been removed",
    "button.award_settings": "Award Settings",
    "pageTitle.payment": "Payment",
    "tasks.return_award": "Revise Award",
    "label.link": "link",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "My Region Office - Related Contacts",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Section Authorisation",
    "table.logs": "Logs",
    "moduleTitle.remove_file": "Remove file?",
    "label.email_confirmed": "Email Confirmed",
    "notifications.activity_has_been_returned": "Activity has been revised",
    "label.note": "Note",
    "button.show": "",
    "tabs.adventurous_journey": "Adventurous Journey",
    "sidebar.my_todolist": "",
    "label.here": "here",
    "organisation.change_award_mode": "Change Awards's Mode",
    "table.note_from_al": "Note from Award Leader",
    "label.gender": "Gender",
    "moduleTitle.remove": "Remove?",
    "errors.must_be_less_than": "Must be less than {limit}",
    "button.logout": "Logout",
    "label.no_selected_participants": "No selected participants",
    "button.new_aj_event": "New Adventurous Journey Event",
    "label.employement_status": "Employment Status",
    "tabs.logs": "Logs",
    "tabs.contacts": "Contacts",
    "label.option": "Option",
    "dashboard.charts": "Charts",
    "notifications.rp_has_been_approved": "Gold Residential Project has been Authorised",
    "pageTitle.new_participant": "New Participant",
    "notifications.award_leader_has_been_approved": "Award leader has been Authorised",
    "moduleTitle.would_you_like_to_remove_leader_training": "Would you like to delete Award Leaders\"s training?",
    "moduleTitle.update_configuration_value": "Update configuration value",
    "table.description": "Description",
    "table.organization": "Organisation",
    "label.youtube": "YouTube",
    "label.author": "Author",
    "table.suitable_for_award_level": "Suitable for Award Level",
    "label.content_update": "Please wait. Updating content...",
    "notifications.new_question_has_been_added": "New question has been added",
    "pageTitle.nao_awards": "National Office - Awards",
    "table.last_name": "Last Name",
    "moduleTitle.adventurous_journey_detail": "Journey Details",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "Project Location Type",
    "label.email_help_award_level": "",
    "label.date": "Date",
    "label.previous_completed_award_place": "Where",
    "button.show_more": "Show more",
    "label.wwc_number": "WWC number",
    "button.filter": "Filter",
    "notifications.rp_has_been_returned": "Gold Residential Project has been revised",
    "pageTitle.residetial_project_assessor_report": "Gold Residential Project - Assessor Report",
    "label.generating": "Generating...",
    "moduleTitle.finance_system_data": "Finance System Data",
    "notifications.adventurous_journey_state_has_been_changed": "Adventurous Journey state has been changed",
    "route.levels": "Levels",
    "moduleTitle.activity_leader": "Activity Leader",
    "tasks.approve_event": "Approve Event",
    "tasks.reject_event": "Revise Event",
    "table.region": "Region",
    "pageTitle.nao_award_leaders": "National Office - Award Leaders",
    "errors.must_be_at_least": "Must be at least {min} characters",
    "table.title": "Title",
    "table.last_activity": "Last Activity",
    "tasks.delete_registration": "Delete Registration",
    "table.date_time": "Local Time",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. The Award Operators are committed to respecting your privacy. Personal information is collected on this form for the purpose of participating in the Award. Participants who do not provide this information to us cannot participate in the Award (note that this does not apply to non-provision of participant data). We may also use your personal information to send you information about other Award activities or events which we believe may be of interest to you. We may disclose this information to other local or international organisations and service providers who assist us in the operation and administration of the Award. If you would like to contact us or access your personal information please write to the Award Operator. You may also contact the Award Operator to request a copy of their privacy policy.",
    "aj.practice_journey": "Practice Journey",
    "notification.log_has_been_restored": "Activity log has been restored",
    "tabs.my_participants": "My Participants",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Supervisor",
    "moduleTitle.your_parental_consent": "Your Parental Consent",
    "route.registration_participants": "Registration participants",
    "placeholder.start_typing": "Start typing...",
    "tasks.approve_award": "Approve Award",
    "route.registrations": "Registrations",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "Adventurous Journey event has been created",
    "states.supervisor_approval": "Assessor Authorisation",
    "label.description": "Description",
    "button.leave_anyway": "Leave anyway",
    "tabs.registrations": "Registrations",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "",
    "pageTitle.nao_registration": "National Office - Registration",
    "pageTitle.mro_logs": "My Region Office - Logs",
    "meta.page_not_found": "Page not found",
    "label.bulk_action_unsuccessful": "",
    "global.days": "days",
    "table.review": "Review",
    "table.as_assessor_for": "As assessor for",
    "roles.if_staff_statistical_user": "IF Statistical User",
    "table.levels": "Levels",
    "label.suitable_for_level": "Suitable for Level",
    "pageTitle.leaders": "Leaders",
    "moduleTitle.send_test_email": "Send Test Email",
    "pageTitle.tasks_removed_registration": "Removed Participant Registrations",
    "label.you_will_be_forced_to_login_again_after_change": "You will be forced to login again after change",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Section Authorisation",
    "pageTitle.payments": "Payments",
    "global.nights": "nights",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Select organisation",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Upload Files",
    "label.migrated_contact_email": "Migrated Contact Email",
    "label.for_award_unit": "For Award Centre",
    "label.aj_template_note": "Template note",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "Please comment on the participants improvement/performance/commitment",
    "label.consent_already_given_login": "Consent was already given. Please login as your child.",
    "participant.level_start_date": "{value} Start Date",
    "sidebar.my_region_office": "My Regional Office",
    "states.section_signoff": "Section Authorisation",
    "moduleTitle.assessor_details": "Assessor Details",
    "moduleTitle.adventurous_journey_settings": "Adventurous Journey Settings",
    "moduleTitle.note_from_al": "Note from Award Leader",
    "button.add_role": "Add Role",
    "table.run": "Run",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "User app guide - Award Leader",
    "tabs.section_approval": "Section Authorisation",
    "roles.award_verifier": "Award Verifier",
    "tabs.activity_approval": "Activity Authorisation",
    "logs.add_log": "Add Log",
    "tabs.award": "Award",
    "notifications.this_role_has_read_only_persmission": "This role has read-only permissions",
    "table.no_filtered_results": "No filtered results",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Location Detail",
    "label.optional": "(optional)",
    "errors.do_not_match": "Do not match",
    "label.use_comma_for_multiple_entries": "Use comma for multiple entries",
    "label.operating_authority": "Operating Partner",
    "label.activity_section": "Activity Section",
    "notifications.you_have_been_logged_out": "You have been logged out",
    "table.finished": "Finished",
    "button.same_as_billing": "Same as Billing",
    "table.payment": "Payment",
    "table.current_level": "Current Level",
    "button.view_nao": "",
    "table.email_confirmation": "Email Confirmation",
    "moduleTitle.shipping_address": "Shipping Address",
    "label.secondary_phone_type": "Secondary Phone Type",
    "notifications.saved": "Saved",
    "pageTitle.all_participants": "All Participants",
    "label.first_name": "First Name",
    "label.oa_price": "OA Price",
    "table.award_mode": "Award mode",
    "tabs.api_keys": "API Keys",
    "award.award_detail": "Award Details",
    "tabs.user_management": "User Management",
    "tabs.all_events": "All Events",
    "notifications.history_record_has_been_removed": "History record has been removed",
    "award.no_data": "No data",
    "notifications.preparation_training_has_been_added": "Preparation and training has been added",
    "label.message": "Message",
    "notifications.participant_info_updated": "Participant information has been updated",
    "roles.nao_staff": "NAO Staff",
    "tabs.adventurous_journeys": "Adventurous Journeys",
    "label.gops": "",
    "route.upload": "Upload",
    "notifications.history_record_has_been_added": "History record has been added",
    "notifications.history_record_has_been_updated": "History record has been updated",
    "label.no_data": "No data",
    "button.add_coordinator": "Add Coordinator",
    "label.you_are_already_logged_as": "You are already logged as ",
    "route.my_national_office": "My National Office",
    "tabs.leaders": "Leaders",
    "label.email_confirmation": "Email Confirmation",
    "table.registration_date": "Registration Date",
    "notifications.role_has_been_removed": "Role has been removed",
    "button.move": "Move",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Details",
    "table.award_unit": "Award Centre",
    "sidebar.settings": "Settings",
    "dashboard.leader_state": "Leaders - by State",
    "notifications.award_unit_has_been_approved": "Award Centre has been Authorised",
    "states.awaiting_approval": "Awaiting Authorisation",
    "table.level": "Level",
    "table.action_requested": "",
    "label.organisation_mode": "Organisation mode",
    "label.no_note": "No note",
    "tabs.my_events": "My Events",
    "notifications.participants_have_been_added": "Participants have been added",
    "tabs.registration_questions": "",
    "button.delete_registration": "Delete Registration",
    "notifications.parental_consent_link_has_been_sent": "Parental consent link has been sent",
    "moduleTitle.select_role_organization": "Select role & organisation",
    "label.experience": "Experience",
    "translationsManagement.modal.title": "",
    "table.ic": "Independent Country",
    "table.id": "ID",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "Would you like to delete this account?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "User web guide - Award Leader",
    "label.journey_type": "Journey Type",
    "button.setup": "Setup",
    "tabs.my_national_office": "My National Office",
    "notifications.training_has_been_removed": "Training has been removed",
    "label.nominated_and_identified_persons": "Nominated and identified persons who can view all data but not edit",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "You have been logged out due to inactivity",
    "states.award_leader_signoff": "Award Leader Authorisation",
    "table.award_signoff_attempts": "Award signoffs attempts",
    "sidebar.regions": "Regions",
    "label.activity_deleted_note": "This activity is deleted. You can restore it by clicking the button below.",
    "table.total": "Total",
    "errors.a_problem_has_occured_during_processing": "A problem has occurred during processing, see more information",
    "participant.participant_already_has_gold_award": "Participant already has a Gold award",
    "pageTitle.mro": "My Regional Office",
    "notifications.authorization_code_has_expired": "Authorisation code has expired",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Adventurous Journey Events",
    "global.loading": "Loading",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Registrations",
    "label.any_string": "Any string",
    "contact.change_contact_status": "Change Contact's Status",
    "tabs.registration": "Registration",
    "label.override_payment_note": "Override payment note",
    "notifications.section_has_been_signed_off": "Section has been signed off",
    "label.payment_date": "Payment Date",
    "button.approve": "Approve",
    "moduleTitle.loggin_in": "Logging in",
    "label.website": "Website",
    "label.role": "Role",
    "table.assessor_report": "Assessor report",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Previously worked as Assessor",
    "pageTitle.registrations": "Registrations",
    "parentalConsent.this_form_must_be_completed": "This form <strong>must</strong> be completed by a parent/guardian for participants under <strong> 18 years of age/the national age of legal responsibility in the country in which you live </strong> by a parent/guardian.",
    "button.apply": "",
    "errors.include_at_least_one_number": "Include at least one number character",
    "label.content_restore": "Refreshing session...",
    "logs.hour": "hour",
    "parentalConsent.i_have_read_and_understand": "7. I have read and understood the different levels and requirements of the Award as set out in the Outline of the Award (page 5 of this form).",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Journey Type",
    "notifications.search_cancelled": "Search was interrupted, you need to wait for the search to finish.",
    "route.detail": "Detail",
    "route.user_guide": "User guide",
    "moduleTitle.history": "History",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Unassigned Participants",
    "states.inactive": "Inactive",
    "pageTitle.search_results": "Search Results",
    "button.proceed_to_login": "Proceed to Login",
    "pageTitle.assessor_report_reject": "Assessor Report Revise",
    "notifications.contact_has_been_removed": "Contact has been removed",
    "sidebar.operating_authorities": "Operating Authorities",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "Preparation and training",
    "route.user_guide_web_leader": "User web guide - Award Leader",
    "label.position_in_organization": "Position in organisation",
    "errors.emails_dont_match": "Email does not match",
    "route.my_participants": "My Participants",
    "pageTitle.customisations": "Customisations",
    "tabs.localization_files": "Localisation Files",
    "table.assessor_approval": "Assessor Authorisation",
    "tabs.related_contacts": "Related Contacts",
    "table.aus": "Award Centres",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Possible values:",
    "label.if_your_download_doesnt_start": "If your download doesn't start automatically please click here",
    "route.independent_award_centres": "Independent Award Centres",
    "pageTitle.user_guide": "User Guides",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "My Organisation - Detail",
    "pageTitle.nao_detail": "National Office - Details",
    "button.change": "Change",
    "award.aj": "Adventurous Journey",
    "table.award_state": "Award State",
    "pageTitle.tasks_award_signoff": "Award Authorisation",
    "pageTitle.regions": "Regions",
    "notifications.award_has_been_signed_off": "Award has been signed off",
    "dashboard.award_approved_by": "Awards Authorised - by level in 2016",
    "tabs.new_template": "New Template",
    "error.parent_email_must_be_filled": "Parent email must be filled in",
    "label.organisation_invoicing_name": "Licensee Name",
    "pageTitle.related_contacts": "Related Contacts",
    "button.try_again": "Close warning and try again",
    "label.cannot_be_change_to_another": "Cannot be changed to another award level",
    "notifications.lead_coordinator_has_been_set": "New Lead Coordinator has been set",
    "label.training_name": "Training Name",
    "moduleTitle.new_contact": "New Contact",
    "translationsManagement.modal.updateTitle": "",
    "moduleTitle.offline_award_units_signoff": "Offline Award Leader signoff",
    "notifications.award_level_has_been_changed": "Award level has been changed",
    "label.subject": "Subject",
    "route.silver_level": "Silver Level",
    "label.privacy_notice": "",
    "label.switch_organization": "Switch Organisation",
    "meta.dofe_name": "The Duke of Edinburgh’s International Award",
    "route.profile": "Profile",
    "roles.super_user": "Super-user",
    "dashboard.while_you_were_gone": "While you were gone",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "Middle Name",
    "moduleTitle.new_activity": "New Activity",
    "organisation.would_you_like_to_remove": "Would you like to remove this organisation?",
    "label.state_province": "State/Province/Region",
    "moduleTitle.your_home_address": "Your home address",
    "tabs.sign_offs": "Authorisations",
    "moduleTitle.logs": "Logs",
    "button.view_more": "View more",
    "label.profile": "Profile",
    "label.title": "Title",
    "tabs.award_signoff": "Award Authorisation",
    "label.post_code": "Post Code",
    "states.ceremony_certificate": "Ceremony",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. I consent to the provision of any personal information that I have provided (including participant data) to the Award Centre and Award Operator. I consent to this information being treated in accordance with the provisions of the privacy policy of the relevant Award Operator (as amended from time to time), the National Privacy Principles contained in the Data Protection Act (UK) 1998 (or any locally equivalent policy or act), and any other privacy legislation, standards, guidelines or instructions binding on them under privacy legislation.",
    "label.user_guide_web_participant": "User web guide - Participant",
    "label.award_unit_type": "Award Centre Type",
    "states.complete": "",
    "table.participant_state": "Participant State",
    "pageTitle.my_organization_payment": "My Organisation - Payment",
    "table.approved": "Authorised",
    "pageTitle.my_organization_contacts": "My Organisation - Contacts",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Change to <strong>{state}</strong>",
    "label.integer": "Integer",
    "notifications.translationUpdateInterrupted": "",
    "notifications.password_has_been_changed": "Password has been changed",
    "button.invite_assessor": "Invite Assessor",
    "label.other_activity": "Other Activity",
    "notifications.parental_consent_has_been_sent": "Parental consent has been sent",
    "button.revise": "Revise",
    "errors.end_date_must_be_after_start_date": "End date must be after start date",
    "label.award_leader_signoff_date": "Award Leader Authorisation date",
    "parentalConsent.i_understand_every_participant_must": "8. I understand every participant must participate in the Award through an Award Centre who has the discretion to accept or reject participants and proposed activities to be undertaken as part of the Award.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Adventurous Journey",
    "global.day": "day",
    "moduleTitle.coordinator": "Coordinator",
    "label.region": "Region",
    "button.add_history_record": "Add history record",
    "moduleTitle.adventurous_journey_template_settings": "Adventurous Journey Template Settings",
    "notifications.personal_details_have_been_updated": "Personal details have been updated",
    "sidebar.ics": "Independent Countries",
    "table.independent_award_centre": "Independent Award Centre",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "UTC Time",
    "moduleTitle.emails": "Emails",
    "label.backoffice": "",
    "moduleTitle.parent_consent": "Parent / Guardian Consent",
    "label.photo_consent_given": "Participant agrees that we can use his/her profile picture for promotion",
    "moduleTitle.authorising_contact": "Authorising Contact",
    "label.assessment_with_role": "{role} assessment",
    "dashboard.type_of_awards": "Type of Award Centre",
    "moduleTitle.payment": "Payment",
    "states.in_progress": "In Progress",
    "logs.no_logs": "No logs",
    "sidebar.my_office": "My Office",
    "label.assessor_report": "Assessor Report",
    "notifications.rp_has_been_signed_off": "Gold Residential Project has been signed off",
    "tabs.labels": "",
    "sidebar.payments": "Payments",
    "meta.profile_questions": "Profile Questions",
    "label.fax": "Fax",
    "label.email_help_custom_link": "",
    "label.last_name": "Last Name",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Participants - by Level",
    "tabs.award_leaders": "Award Leaders",
    "label.i_confirm_that_ive_witnessed": "I confirm that I've witnessed the Participants log book for the activities below",
    "table.lead_coordinator": "",
    "states.deleted": "Deleted",
    "label.no_answers": "No answers",
    "button.add": "Add",
    "label.exchequer_number": "Exchequer A/c No.",
    "label.waiting": "Waiting",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Revise Registration",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Parent Authorisation",
    "table.assessor_approve": "Assessor approve",
    "errors.some_fields_requires_your_attention": "Some fields require your attention",
    "aj.qualifying_journey": "Qualifying Journey",
    "route.awards": "Awards",
    "table.registration": "Registration",
    "pageTitle.assessors": "Assessors",
    "notifications.award_has_been_updated": "Award has been updated",
    "errors.must_be_one_of": "Must be one of: {enums}",
    "pageTitle.logs": "Logs",
    "notifications.notifications.invitation_has_been_sent": "Invitation has been sent",
    "route.national_offices": "National Offices",
    "notifications.training_has_been_updated": "Training has been updated",
    "label.parent_last_name": "Last name of Parent / Guardian",
    "table.leaders": "Leaders",
    "states.award_level_complete": "Award Level Complete",
    "button.reset": "Reset",
    "sidebar.my_award_unit": "My Award Centre",
    "pageTitle.all_aj_events": "All Adventurous Journey Events",
    "label.activity": "Activity",
    "moduleTitle.are_you_sure": "Are you sure?",
    "route.gold_level": "Gold Level",
    "table.evidence": "Evidence",
    "label.delivery_confirmed": "Delivery Confirmed",
    "parentalConsent.as_the_parent": "As the parent/guardian, I give consent for any images to be used by the Foundation for promotional purposes.",
    "label.awardMode.offline": "Offline",
    "tasks.approve_registration": "Approve Registration",
    "note.change_the_email_will_change": "Note: Changing the Email will change also the Migrated Contact email",
    "notifications.participant_has_been_approved": "Participant has been Authorised",
    "label.reached_activity_limit": "Activities limit reached in this activity section. Participant can have maximum of 3 activities in each section.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Preparation and training has been removed",
    "pageTitle.settings": "Settings",
    "participant.level_registration_date": "{value} Registration Date",
    "notifications.question_has_been_removed": "Question has been removed",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "Leaders",
    "notifications.participants_have_been_transferred": "Participants have been transferred",
    "tabs.assessors": "Assessors",
    "sidebar.dashboard": "Dashboard",
    "pageTitle.independent_award_centers": "Independent Award Centres",
    "label.search": "Search",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Note from participant",
    "errors.required_field": "Required field",
    "tasks.approve_task": "Approve Task",
    "logs.edit_log": "Edit Log",
    "table.state": "State",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "Close",
    "label.parent_first_name": "First name of Parent / Guardian",
    "parentalConsent.i_understand_that_the_participant": "1. I understand that the participant cannot participate in the Award until this form has been completed (including parent/guardian consent) and returned to the relevant Award Operator with the applicable registration fee, and has then been accepted by the Award Centre.",
    "tabs.award_units": "Award Centres",
    "table.hours": "Hours",
    "label.type": "Type",
    "notifications.adventurous_journey_has_been_removed": "Adventurous journey has been removed",
    "label.aj_is_not_approved_yet": "Adventurous Journey is not Authorised yet",
    "roles.authorizing_contact": "Authorizing Contact",
    "table.date_submitted_to_office_signoff": "Date Submitted to Award Office Authorisation",
    "notifications.section_has_been_returned": "Section has been revised",
    "table.created_by": "Created by",
    "route.user_guide_web_participant": "User web guide - Participant",
    "route.templates": "Templates",
    "states.awaiting_sign_off": "Award Leader Authorisation",
    "table.phone": "Phone",
    "label.parental_consent": "Parental Consent",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Bronze Level",
    "label.invoice_currency": "Invoice Currency",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "Server cannot be reached at the moment. Please try again later. If the problem persists, please contact our support team.",
    "notifications.contact_has_been_created": "Contact has been created",
    "pageTitle.profile_questions": "Profile Questions",
    "table.observation_files": "Observation files",
    "table.participants": "Participants",
    "tasks.no_evidence": "No evidence provided",
    "button.edit": "Edit",
    "moduleTitle.leader": "Leader",
    "notifications.new_template_has_been_updated": "New template has been updated",
    "table.name": "Name",
    "label.no_results": "No results",
    "moduleTitle.documents": "Documents",
    "button.invite": "Invite",
    "label.goal": "Goal",
    "pageTitle.nao_award_units": "National Office - Award Centres",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "At least {length} characters long",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Remove role?",
    "label.total": "Total",
    "label.delete_participant_award_info": "",
    "route.leaders": "Leaders",
    "table.start_date": "Start Date",
    "moduleTitle.coordinators": "Coordinators",
    "button.create": "Create",
    "tabs.awards": "Awards",
    "parentalConsent.form_has_been_sent": "Parental consent has been sent.",
    "states.journey_approval": "Journey Authorisation",
    "pageTitle.reports": "Reports",
    "table.journey_type": "Journey Type",
    "label.yes": "Yes",
    "pageTitle.assessor_report": "Assessor Report",
    "label.organization": "Organisation",
    "notifications.award_leader_has_been_updated": "Award Leader has been updated",
    "moduleTitle.edit_role": "Edit Role",
    "table.journey_activity": "Journey Activity",
    "label.location": "Location",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Adventurous Journeys",
    "global.assessor": "Assessor",
    "moduleTitle.profile_questions": "Profile Questions",
    "activity.cannot_edit_activity_if_award_in_state": "Cannot edit activity if award is in {state} state",
    "moduleTitle.assessor_detail": "Assessor Details",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. I understand that upon acceptance into the Award by the Award Centre, the participant will receive a Record Book or gain access to the Online Record Book (ORB). The participant will read the requirements of the Award contained in the Record Book or ORB prior to starting activities in relation to the Award. I understand that the Award Centre has the discretion to determine whether the Award requirements have been met and therefore whether a Bronze, Silver or Gold Award should be issued. I understand that the Award Operator may provide participants with limited insurance in respect of personal accident and public liability insurance starting upon acceptance into the Award by the Award Centre, but that the responsibility for obtaining and maintaining personal accident cover lies with the participant/and their parent/guardian.",
    "notifications.award_has_been_returned": "Award has been revised",
    "label.code_of_conduct": "",
    "button.new_contact": "New Contact",
    "tabs.payments": "Payments",
    "roles.naa_oa_staff": "NAA OA Staff",
    "label.switch_organisation_hint": "You can open this dialog anytime by choosing 'Switch Organisation' in the upper-right corner menu",
    "label.expiration_date": "Expiration Date",
    "tabs.participants": "Participants",
    "table.practice": "Practice",
    "notifications.one_activity_has_to_remain": "One activity in section has to remain active",
    "label.qualifications": "Qualifications",
    "states.organization_approval": "Award Office Authorisation",
    "errors.must_be_an_integer": "Must be an integer",
    "participant.send_confirmation_email_again_question": "Send confirmation email again?",
    "button.dismiss": "Dismiss",
    "table.advice": "",
    "label.years_of_working_experience": "Years of working experience",
    "notifications.search_failed": "There was an error while searching. Please try again later.",
    "notifications.changes_have_been_saved": "Changes have been saved",
    "moduleTitle.resend_parental_consent_link": "Resend parental consent link?",
    "label.activity_type": "Activity Type",
    "label.change_award": "Change Award Level",
    "label.email": "Email",
    "button.remove": "Remove",
    "button.download": "Download",
    "label.vat_treatment": "VAT Treatment",
    "pageTitle.aj_template_new": "New Adventurous Journey Template",
    "table.per_page": "per page",
    "notifications.translations_has_been_updated": "",
    "notification.award_mode_has_been_updated": "Award's mode has been updated",
    "tasks.revise_item": "Revise Item",
    "button.resend_parental_consent": "Resend parental consent",
    "table.weeks_completed_required": "Weeks Completed / Required",
    "label.last_modified": "Last modified",
    "table.major": "Major",
    "label.vat_number": "VAT No.",
    "errors.passwords_dont_match": "Passwords do not match",
    "table.country": "Country",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Question has been updated",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Authorization code is no longer valid",
    "errors.must_be_no_more_than": "Must be no more than {max} characters",
    "notifications.event_has_been_rejected": "Event has been revised",
    "tabs.customizations": "Customisations",
    "label.name_organization": "Name",
    "button.add_log": "Add Log",
    "moduleTitle.invite_assessor": "Invite Assessor",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "All participants will be transfered to a new Award Leader",
    "label.repeat_email": "Repeat Email",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "Role has been updated",
    "roles.if_staff_stat_user": "IF Statistical User",
    "participant.delete_account": "Delete Contact",
    "moduleTitle.would_you_like_to_remove_this_log": "Would you like to delete this log?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Journey Type",
    "sidebar.manual_data_import": "Manual data import",
    "label.created_after_date": "Created after",
    "route.my_organization": "My Organisation",
    "button.show_list": "",
    "label.leaders": "Leaders",
    "notifications.log_has_been_modified": "Log has been modified",
    "button.upload_file": "Upload File",
    "moduleTitle.which_section_do_you_want_to": "Which section do you want to return to 'In Progress'?",
    "tabs.bronze_level": "Bronze Level",
    "notifications.participants_have_been_saved": "Participants have been saved",
    "pageTitle.aj_template_detail": "Adventurous Journey",
    "label.parent_email": "Parent&#39;s / Guardian&#39;s Email",
    "map.appr_location": "Approximate address:",
    "notifications.log_has_been_removed": "Log has been removed",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "Stay",
    "table.previous_level": "Previous Level",
    "label.award_start_date": "Award Start Date",
    "assessor_report.returned_to_participant": "Returned to Participant",
    "pageTitle.tasks_assessors_registration": "Assessor Registration",
    "aj.cannot_modify_award": "The Award Level cannot be modified if participants are assigned to the Adventurous Journey",
    "moduleTitle.lost_internet_connection": "It looks like you lost internet connection",
    "states.ceremony": "Ceremony",
    "participant.reactivate_account": "Reactivate account",
    "label.birthdate": "Date of Birth",
    "pageTitle.assessment_send_successfully": "Assessment sent successfully",
    "states.assessor_approval": "Assessor Authorisation",
    "award.change_award_level": "Change Award Level",
    "label.url_no_longer_valid": "This URL is no longer valid.",
    "button.update": "Update",
    "label.secondary_email": "Secondary Email",
    "button.role_edit": "Edit",
    "table.award_leader": "Award Leader",
    "label.level": "Level",
    "tasks.evidence": "Evidence",
    "notifications.participant_is_already_in_list": "Participant is already in the list",
    "button.clear": "Clear",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Setup",
    "table.activity": "Activity",
    "label.copy_to_clipboard": "",
    "route.award_units": "Award Centres",
    "button.upload_photo": "Upload Picture",
    "table.hours_completed_required": "Hours Completed / Required",
    "table.first_name": "First Name",
    "notifications.adventurous_journey_has_been_returned": "Adventurous Journey has been revised",
    "pageTitle.national_offices": "National Offices",
    "notifications.you_have_been_logged_in": "You have been logged in",
    "logs.offline": "",
    "moduleTitle.add_role": "Add role",
    "label.user_app_guide_participant": "User app guide - Participant",
    "notifications.file_has_been_removed": "File has been removed",
    "label.send_message": "",
    "button.select": "Select",
    "label.reason_of_deletion": "Reason for deletion",
    "label.user_guide": "User guide",
    "pageTitle.nao_participants": "National Office - Participants",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Uploaded by",
    "tasks.approve_item": "Approve Item",
    "tasks.restore_participant_registration": "Restore participant registration?",
    "label.awardMode.hybrid": "Hybrid",
    "table.first_activity_started": "First activity started",
    "moduleTitle.dates": "Dates",
    "table.no_results": "No results",
    "states.registration_approval": "Registration Authorisation",
    "table.breakdown_of_hours": "Breakdown of hours",
    "pageTitle.tasks_registration": "Participant Registration",
    "button.create_new": "Create New",
    "sidebar.todolist": "To Do List",
    "label.active_participants": "Active Participants",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Revise Task",
    "organisation.change_organisation_state": "Change Organisation's State",
    "moduleTitle.roles": "Roles",
    "label.no_config_key_available": "No configuration keys available for this section",
    "placeholder.selectLanguage": "",
    "states.office_signoff": "Award Office Authorisation",
    "notifications.translations_has_been_updated.failure": "",
    "logs.minute": "minute",
    "label.last_activity": "Last Activity",
    "sidebar.user_guide": "User Guides",
    "label.trained_award_leader": "a trained Award Leader",
    "table.progress": "Progress",
    "table.suboperating_authorities": "Sub-Operating Authorities",
    "activity.cannot_edit_activity_offline": "This Participant is operating in Offline mode.<br><br>\nYou cannot edit; activity, adventurous journey or Gold Residential Project if the Award is in semi-offline mode.",
    "label.user_does_not_have_permissions": "User <strong>{user}</strong> doesn't have permissions to see this content.",
    "notifications.assessor_has_been_approved": "Assessor has been Authorised",
    "route.activity_approval": "Activity Authorisation",
    "moduleTitle.role": "Role",
    "button.run": "Run",
    "label.to": "To",
    "notifications.file_has_been_updated": "File has been updated",
    "moduleTitle.edit_coordinator": "Edit Coordinator",
    "notifications.authorization_code_is_no_longer_valid": "Authorization code is no longer valid",
    "button.reject": "Revise",
    "label.label.participant_status": "Participant Status",
    "award.gold_level": "Gold Level",
    "sidebar.variables": "Variables",
    "parentalConsent.checkbox_copy": "I confirm that I am the parent/guardian of {firstName} {lastName}. I give my consent for him/her to participate in the Award in {organisationName} under supervision of a trained Award Leader. I have read, understood and agree with the requirements and conditions of participation in the Award, as described above and on the website of the Award Operator.",
    "button.go_to_dashboard": "Go to dashboard",
    "button.add_option": "Add option",
    "label.is_completed": "Completed",
    "pageTitle.award_units": "Award Centres",
    "states.completed": "Completed",
    "button.adventurous_journey_template_settings": "Adventurous Journey Template Settings",
    "label.system_rights": "System Rights",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "Login",
    "label.name_of_the_unit": "Name of the unit",
    "button.send": "Send",
    "award.ajs": "Adventurous Journeys",
    "meta.payments_expired": "Payments - Expired",
    "label.age": "Age",
    "notifications.payment_info_updated": "Payment information has been updated",
    "table.is_completed": "Completed",
    "table.invited_by": "Invited by",
    "route.files": "Files",
    "route.assessors": "Assessors",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "My Participants",
    "label.change_leader_status": "Change Leader's Status",
    "moduleTitle.parent_consent_form": "Parent / Guardian Consent Form",
    "notifications.authorization_contact_has_been_set": "Authorisation contact has been set",
    "button.close": "Close",
    "label.independent_country": "Independent Country",
    "notifications.aj_preparation_training_has_been_returned": "Adventurous Journey Preparation & training has been revised",
    "route.history_log": "History Log",
    "participant.account_settings": "Account Settings",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "File URL is not specified in configuration",
    "notifications.award_unit_has_been_removed": "Award Centre/IAC has been removed",
    "table.parent": "Parent",
    "label.mode_of_transport": "Mode of Travel",
    "label.parental_consent_email_info": "Do not forget to check parent email and send the consent manually from award detail screen.",
    "label.current_award": "Current Award",
    "table.action": "Action",
    "pageTitle.suboperating_authorities": "Sub-Operating Authorities",
    "notifications.award_leader_has_been_assigned": "Award leader has been assigned",
    "tabs.sign_offs_locally": "Local Authorisation",
    "Activity log has been restored": "notification.log_has_been_restored",
    "sidebar.naos": "NAOs",
    "tabs.aj_templates": "Adventurous Journey Templates",
    "notifications.logging_out": "Logging out...",
    "label.update_label": "",
    "button.organisation_settings": "Organisation Settings",
    "tabs.independent_award_centers": "Independent Award Centres",
    "label.current": "Current",
    "table.location": "Location",
    "button.search": "Search",
    "notifications.aj_preparation_training_has_been_approved": "Adventurous Journey Preparation & training has been Authorised",
    "route.participants": "Participants",
    "label.other_location_information": "Other Location Information",
    "label.number_of_records": "Number of records",
    "translationsManagement.infoLabel": "",
    "parentalConsent.i_consent_to_pay_all": "5. I consent to pay all such doctors, nurses or hospital accommodation fees and expenses incurred on behalf of the participant as a result of any such accident, injury, illness or loss suffered by the participant whilst participating in, or travelling to and from, any activities or functions related to the Award.",
    "label.nationality": "Nationality",
    "states.approval": "Authorisation",
    "notifications.something_went_wrong": "Something went wrong",
    "aj.practice": "Practice",
    "label.addressLine2": "Address Second Line",
    "label.please_leave_a_note": "Please leave a note",
    "placeholder.select": "Select",
    "label.observations": "Observations",
    "label.aim": "Goal",
    "label.addressLine1": "Address First Line",
    "roles.aj_instructor": "AJ Instructor",
    "meta.payments_waiting": "Payments - Waiting",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instructor",
    "moduleTitle.remove_customization_and_reset": "Remove customization and reset config value?",
    "notifications.participant_registration_has_been_restored": "Participant registration has been restored",
    "organisation.change_award_unit_mode": "Change Organisation's Mode",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Participant has been deleted",
    "label.language_settings": "Language Settings",
    "notifications.event_has_been_approved": "Event has been Authorised",
    "label.password": "Password",
    "label.text": "Text",
    "table.observations": "Observations",
    "notifications.participant_has_been_created": "Participant has been created",
    "table.note_for_al": "Note for Award Leader",
    "label.payment_confirmed": "Payment Confirmed",
    "label.previous_completed_award_level": "Previous Level (not ORB)",
    "pageTitle.new_aj_event": "New Adventurous Journey Event",
    "label.backend": "",
    "label.relationship_to_participant": "Relationship to participant",
    "award.physical_recreation": "Physical Recreation",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "Assessor Report Reject",
    "label.supervisor_report": "Supervisor Report",
    "table.role": "Role",
    "route.user_guide_web_nao": "User web guide - NAO",
    "label.page_not_found": "404 - Page not found.",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "File has been uploaded",
    "moduleTitle.address": "Address",
    "moduleTitle.lead_coordinator": "Lead Coordinator",
    "pageTitle.login": "Login",
    "label.frontoffice": "",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Gold Residential Project has been set up",
    "moduleTitle.award_unit": "Award Centre",
    "button.remove_file": "Remove file",
    "moduleTitle.billing_address": "Billing Address",
    "pageTitle.my_aj_events": "My Adventurous Journey Events",
    "route.tasks": "Tasks",
    "button.confirm": "Confirm",
    "label.national_award_authority": "National Award Authority",
    "label.independent_award_centre": "Independent Award Centre",
    "award.generate_award_report": "Generate Report",
    "route.my_region_office_customization": "My Regional Office - Customisations",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Password change request has been sent",
    "tabs.detail": "Detail",
    "participant.change_participant_status": "Change Participant's Status",
    "table.key": "Key",
    "label.find_address": "Find Address",
    "notifications.assessor_has_been_rejected": "Assessor has been revised",
    "label.transfer_participants": "Transfer Participants",
    "button.continue_to_payment_gateway": "Continue to payment gateway",
    "notifications.participant_registration_has_been_removed": "Participant registration has been removed",
    "moduleTitle.page_not_found": "404 - Page not found",
    "route.adventurous_journeys": "Adventurous Journeys",
    "states.registration_assessment": "Registration Assessment",
    "heading.change_award_unit_mode": "Change Award Centre's mode",
    "label.user_guide_web_nao": "User web guide - NAO",
    "tabs.silver_level": "Silver Level",
    "table.paid_by": "Paid by",
    "label.your_report_has_been_successfully_sent": "Your report has been successfully sent.",
    "sidebar.my_organization": "My Organisation",
    "pageTitle.participants": "Participants",
    "notifications.preparation_training_has_been_updated": "Preparation and training has been updated",
    "moduleTitle.server_is_unreachable": "Server is unreachable",
    "label.last_activity_date": "",
    "award.bronze_level": "Bronze Level",
    "moduleTitle.award_units": "Award Centres",
    "table.completed": "Completed",
    "moduleTitle.revise_message": "Revise message",
    "table.lastUsed": "Last used",
    "award.bronze_to_gold_level": "Bronze to Gold Level",
    "button.change_password": "Change password",
    "label.nao_price": "NAO Price",
    "label.payment_state": "Payment State",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "Award Office Authorisation date",
    "label.award_unit": "Award Centre",
    "award.gold_level_short": "Gold",
    "moduleTitle.other_info": "Other Information",
    "table.note": "Note",
    "label.search_by_email_first_or_last": "Search by email, first or last name",
    "tabs.history": "History",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Unassigned Participants",
    "table.main_award_leader": "Coordinator",
    "parentalConsent.i_as_the_parent": "3. I understand that certain activities are considered high-risk and that high-risk activities may not be covered by the insurance arrangements of the Award Operator. I understand that the responsibility for all risks arising from the participant’s participation in the Award is placed solely upon the participant.",
    "label.state": "State",
    "notifications.award_leader_has_been_removed": "Award Leader has been removed",
    "tabs.organization_detail": "Organisation Details",
    "table.operating_authorities": "Operating Authorities",
    "label.available_labels": "",
    "modal.select": "Select",
    "tabs.expired_payments": "Expired Payments",
    "moduleTitle.note_for_al": "Note for Award leader",
    "moduleTitle.confirm": "Confirm",
    "notification.new_activity_added": "New activity has been added",
    "notifications.award_leader_has_been_moved": "Award leader has been moved",
    "label.award_mode": "Award Mode",
    "label.phone": "Phone",
    "notifications.organization_has_been_updated": "Organisation has been updated",
    "moduleTitle.assessor": "Assessor",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "Parent Authorisation",
    "label.date_of_delivery": "Date Received",
    "sidebar.assessors": "Assessors",
    "label.journey_activity": "Journey Activity",
    "award.inactive_award": "Inactivate Award",
    "label.end_date": "End Date",
    "label.orb_testing": "",
    "label.no_activities": "No activities",
    "moduleTitle.please_confirm": "Please confirm",
    "button.login_with_another_account": "Login with different account",
    "tasks.reject_registration": "Revise Registration",
    "label.submitted_after_date": "Submitted after",
    "label.update_translations_successful": "",
    "button.assign_leader": "Assign Leader",
    "table.already_running": "Already running",
    "label.no": "No",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "Secondary Phone Number",
    "label.my_experience": "My Experience",
    "notifications.adventurous_journey_has_been_approved": "Adventurous Journey has been Authorised",
    "pageTitle.mro_detail": "My Regional Office - Details",
    "moduleTitle.nao_specific_info": "NAO Specific Information",
    "label.preparing_document_for_import": "Preparing document for import",
    "tasks.observations": "Observations",
    "notifications.confirmation_email_has_been_sent": "Confirmation email has been sent",
    "button.restore": "Restore",
    "label.importing_file": "Importing file",
    "label.or_dont_agree": "Or don't agree? You can",
    "moduleTitle.award_leader": "Award Leader",
    "label.me": "(me)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Export Table",
    "organisation.move_award_unit": "Move Award Centre",
    "label.file_category": "",
    "notifications.connecting_to_server": "Connecting to server...",
    "parentalConsent.i_understand_that_a_and_b": "11. I understand that: <br /> a. a participant must not drive a motor vehicle or transport other participants participating in activities related to the Award unless the participant holds an appropriate and valid driving licence and there is appropriate third party insurance in place to cover any person injured as a consequence of the participant’s driving; and <br /> b. a participant must not be driven by any individual who is not involved in or assisting in organising the Award for the purposes of participating in the Award unless the individual holds an appropriate and valid driving licence and there is appropriate third party insurance in place to cover any person injured as a consequence of the individual’s driving.",
    "table.reason": "",
    "pageTitle.contacts": "Contacts",
    "states.award_leader_approval": "Award Leader Authorisation",
    "meta.payments": "Payments",
    "label.suboperating_authority": "Sub-Operating Partner",
    "route.my_region_office": "My Regional Office",
    "states.registration_not_approved": "Registration not Authorised",
    "label.direct_entrant": "Direct entrant",
    "tabs.all_participants": "All Participants",
    "tabs.payment": "Payment",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Repeat New Password",
    "label.other_roles": "",
    "logs.hours": "hours",
    "notifications.spreadsheet_has_been_imported_successfully": "Spreadsheet has been imported successfully",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "Personal Details",
    "label.bulk_action_emailing": "",
    "route.my_events": "My Events",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Include both lower and upper case characters",
    "tabs.removed_participant_registrations": "Removed Participant Registrations",
    "sidebar.mynao": "My NAO",
    "tabs.office_details": "Office Details",
    "label.major": "Major",
    "tabs.documents": "Documents",
    "label.new_password": "New Password",
    "sidebar.adventure_journey": "Adventurous Journey",
    "pageTitle.customizations": "Customisations",
    "moduleTitle.assessor_report": "{role} report",
    "label.registration_date": "Registration Date",
    "notifications.training_has_been_added": "Training has been added",
    "aj.qualifying": "Qualifying",
    "moduleTitle.you_have_been_logged_out_session_terminated": "You have been logged out because the session has already been terminated",
    "award.service": "Voluntary Service",
    "notifications.rp_state_has_been_changed": "Gold Residential Project state has been changed",
    "label.ctest_access": "",
    "table.created": "Created",
    "tasks.revise_task": "Revise Task",
    "button.assign": "Assign",
    "button.return": "Revise",
    "table.status": "Status",
    "button.restore_activity": "Restore Activity",
    "tabs.new_aj_event": "New Adventurous Journey Event",
    "roles.if_staff_viewer": "IAF Staff Viewer",
    "notifications.new_template_has_been_created": "New template has been created",
    "global.something_went_wrong": "Something went wrong",
    "table.expire_day": "Expire day",
    "tabs.history_log": "History Log",
    "label.form_of_payment": "Form of Payment",
    "button.add_training": "Add training",
    "label.par_reg_cust_note": "This tab allows you to customise fields that are displayed at the Participant Registration and affect the amount of data you are collecting.  Please contact your Regional Office if you wish changes to be made - only IAF Sys Admin have access to make these changes.",
    "label.my_qualification": "My Qualification",
    "button.add_new_profile_question": "Add new profile question",
    "table.operating_authority": "Operating Partner",
    "table.aim": "Goal",
    "table.awards": "Awards",
    "participant.deactivate_account": "Deactivate account",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Date",
    "tasks.would_you_like_to_delete": "Would you like to delete this participant?",
    "notifications.configuration_value_has_been_updated": "Configuration value has been updated",
    "ajTemplates.fill_from_template": "Fill from template",
    "contact.send_test_email": "Send Test Email",
    "moduleTitle.aj_preparation_and_training": "Adventurous Journey preparation & training",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "Parent&#39;s / Guardian&#39;s Phone Number",
    "label.nao_regulations": "",
    "award.skills": "Skills",
    "label.reject_application": "reject this application.",
    "leader.delete_account": "Delete Contact",
    "table.assign": "Assign",
    "roles.aj_supervisor": "Adventurous Journey Supervisor",
    "label.logout": "Logout",
    "moduleTitle.award_leader_edit": "Edit Award Leader",
    "moduleTitle.training": "Training",
    "notifications.coordinator_has_been_removed": "Coordinator has been removed",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Coordinator",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "Preparation",
    "table.delete": "Delete",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Reports",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "Operating Authorities",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Confirmed",
    "notifications.invitation_has_been_sent": "Invitation has been sent",
    "pageTitle.independent_countries": "Independent Countries",
    "label.assessors_email": "Assessor's Email",
    "tasks.approve_assessor_registration": "Approve Assessor Registration",
    "table.award_duration": "Award Duration",
    "notifications.organization_has_been_moved": "Organisation has been moved",
    "pageTitle.nao_payment": "National Office - Payment",
    "participant.history_log": "History Log",
    "label.rejected_with_note": "",
    "label.already_running": "Already running",
    "button.continue": "",
    "award.no_data_to_show": "No data to show",
    "participant.send_email_invitation_again_question": "Send email invitation again?",
    "label.reason_for_changing_assessor": "Reason for changing the assessor",
    "button.delete": "Delete",
    "moduleTitle.requirements_and_conditions": "Requirements and Conditions",
    "roles.leader": "Leader",
    "label.if_download_doesnt": "If download doesn't start automatically, please check popup settings in your browser",
    "dashboard.your_todo_list": "Your To Do List",
    "notifications.award_unit_has_been_returned": "Award Centre has been revised",
    "moduleTitle.participant_activities": "Participant's activities",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Active Leaders",
    "aj.preparation": "Preparation",
    "button.change_state": "Change State",
    "label.current_password": "Current Password",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Contact Settings",
    "button.remove_photo": "Remove Photo",
    "notifications.activity_has_been_setup": "Activity has been set up",
    "errors.must_be_more_than": "Must be more than {limit}",
    "table.goal": "Goal",
    "notifications.coordinator_has_been_set": "Coordinator has been set",
    "label.cc": "Cc",
    "label.duration": "Duration",
    "table.actions": "Actions",
    "participant.send_email_invitation_again": "Send email invitation again?",
    "moduleTitle.would_you_like_to_remove_participant": "Would you like to delete this participant registration?",
    "parentalConsent.i_authorise_employees": "4. I authorise employees, officers or agents of the Award Centre and any other individuals who participate in, are involved in or assist in organising the Award, in the event of any accident, injury, illness or loss suffered by the participant whilst participating in, or travelling to and from, any activities or functions related to the Award, to obtain any necessary medical assistance or treatment including, but not limited to, engaging any doctors, nurses or hospital accommodation.",
    "button.reload_page": "Reload Page",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "Email",
    "label.new_goal": "New Goal",
    "label.participant_survey_parent": "I consent to my child, {firstName} {lastName}, to be given the opportunity to participate in the surveys the Award conducts to understand the award experience of participants, measure the outcomes and impact of the Award and other research activity that is in line with the Award's strategy and aims. For more information about the current research activity, please click <a href={url}>here</a>",
    "errors.invalid_email_address": "Invalid email address",
    "pageTitle.new_contact": "New Contact",
    "sidebar.gops": "",
    "button.manage_participants": "Manage Participants",
    "errors.invalid_phone_format": "Invalid phone number",
    "notifications.login_details_have_been_changed": "Login details have been changed",
    "moduleTitle.participant_logs": "Participant's logs",
    "label.save": "Save",
    "label.frequently_asked_questions": "Frequently Asked Questions (FAQs)",
    "label.city": "City",
    "notifications.configuration_value_has_been_reset": "Configuration value has been reset",
    "states.office_sign_off": "Award Office Authorisation",
    "button.save": "Save",
    "button.import_data_from_selected_file": "Import data from selected file",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. I understand that the participant cannot commence any particular section of the Award until I have satisfied myself that any volunteer nominated by the participant, who is not an employee of the Award Centre, is suitably experienced and/or qualified to instruct/supervise/assess that section of the Award; and until any relevant volunteers have completed and returned required documentation to the Award Centre.",
    "pageTitle.apiKeys": "API Keys",
    "label.international_region": "International Region",
    "tabs.levels": "Levels",
    "tabs.additional_files": "Additional Files",
    "label.continuation_level": "Continuation Level",
    "table.adventurous_journey_detail": "Adventurous Journey Details",
    "button.set": "Set",
    "label.i_certify_that_as_the_assessor": "I certify that as the {role} of this activity that the participant has met the requirements.",
    "table.coordinator": "Coordinator",
    "participant.send_confirmation_email_again": "Send confirmation email again?",
    "table.report": "Report",
    "label.update_translations_results": "",
    "table.observation_note": "Observation Note",
    "label.view_more": "View More",
    "notifications.payment_link_has_been_reset": "Payment link has been reset",
    "table.type": "Type",
    "moduleTitle.updateConfigurationKey": "Update configuration key",
    "sidebar.independent_award_centers": "Independent Award Centres",
    "table.activity_type": "Activity Type",
    "label.awardMode.online": "Online",
    "table.data_state": "Last Data Refresh",
    "button.generate_report": "Generate Report",
    "moduleTitle.assessed_by_award_leader": "Assessed by Award leader",
    "table.child_protection_number": "Child protection number",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "Award State",
    "moduleTitle.overview": "Overview",
    "table.aj_detail": "Adventurous Journey Detail",
    "pageTitle.tasks_activity_approvals": "Activity Authorisation",
    "label.section": "Section",
    "route.history": "History",
    "route.event_participants": "Event Participants",
    "participant.account_detail": "Account Settings",
    "route.dashboard": "Dashboard",
    "table.payments": "Payments",
    "pageTitle.profile": "Profile",
    "organisation.remove_organisation": "Remove Organisation",
    "pageTitle.my_organization": "My Organisation",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "Assessor has been updated",
    "label.participant_personal_reflection": "",
    "button.add_key": "Add key",
    "header.appMotto": "DUKE",
    "table.qualifying": "Qualifying",
    "button.upload": "Upload",
    "button.resend": "Resend",
    "label.filename": "Filename",
    "label.change_parental_consent": "",
    "button.cancel": "Cancel",
    "label.aply_to_all_langs": "",
    "route.customization": "Customisation",
    "errors.minimal_duration_is": "Minimal duration is 30 min",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Participant Status",
    "award.bronze_level_short": "Bronze",
    "label.phone_type": "Phone Type",
    "global.night": "night",
    "button.adventurous_journey_settings": "Adventurous Journey Settings",
    "participant.leader_must_be_selected": "Leader must be selected",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "User Added Preparation and Training",
    "table.approve": "Approve",
    "label.role_in_organisation": "Role in Organisation",
    "states.finished": "Finished",
    "label.created": "Created",
    "button.back_to_home": "Back to Home",
    "label.options": "Options",
    "contact.next_level_invitation": "Next level invitation",
    "moduleTitle.activity_detail": "Activity Detail",
    "route.section_signoff": "Section Authorisation",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Contact Settings",
    "label.transation_id": "Transaction ID",
    "notifications.activity_has_been_updated": "Activity has been updated",
    "sidebar.awards": "Awards",
    "parentalConsent.images_consent": "As the parent/guardian, I give consent for any images to be used by the Foundation for promotional purposes.",
    "participant.would_you_like_to_delete": "Would you like to delete this account?",
    "roles.user": "Statistical",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "No results",
    "moduleTitle.address_line_2": "Address Second Line",
    "states.awaiting_office_sign_off": "Award Office Authorisation",
    "moduleTitle.export": "Export",
    "moduleTitle.address_line_1": "Address First Line",
    "notifications.participant_has_been_assigned": "Participant has been assigned",
    "roles.viewer": "Viewer",
    "label.participants_total": "Participants total",
    "errors.auth_code_is_no_longer_valid": "Authorisation code is no longer valid - it may have been used or has expired",
    "label.file_is_not_available": "File is not available",
    "button.select_template": "Select Template",
    "label.payment": "Payment",
    "award.silver_level_short": "Silver",
    "table.participant_id": "",
    "text.hours_old": "{hours} hours old",
    "moduleTitle.your_personal_information": "Your Personal Information",
    "aj.minimum_date_recommendation": "Minimum date recommendation for Practice AJ and {name} is",
    "label.date_of_payment": "Date of Payment",
    "button.view": "View",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "Set Participants",
    "roles.assessor": "Assessor",
    "moduleTitle.coordinator_settings": "Coordinator Settings",
    "label.parent_relationship": "Parent&#39;s relationship",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "Email has been sent",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "Sub-Operating Authorities",
    "route.award": "Award",
    "label.no_roles": "No roles",
    "table.files": "Files",
    "aj.minimum_date_requirements": "Minimum date requirement for Qualifying AJ and {name} is",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "Participant is Offline",
    "moduleTitle.other_coordinators": "Other Coordinators",
    "button.updateSelectedLanguage": "",
    "tasks.approve_award_registration": "Approve Award Registration",
    "participant.invite_participant_to_next_level": "Invite participant to next level?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Awards",
    "warning.award_marked_as_paid": "",
    "table.edit": "Review",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "International Award",
    "moduleTitle.after_assigning_a_role_to_yourself": "After assigning or changing a role for yourself you'll required to login again.",
    "label.transaction_id": "Transaction ID",
    "table.suboperating_authority": "Sub-Operating Partner",
    "label.participant_survey": "As an Award Participant I am happy to participate in the Foundation Surveys",
    "label.created_by": "Created by",
    "button.send_confirmation_email_again_question": "Send confirmation email again",
    "label.email_help_award_leader_email": "",
    "label.name": "Name",
    "tabs.gold_level": "Gold Level",
    "pageTitle.award_documents": "Award Documents",
    "label.online_payments": "Online Payments",
    "label.child_protection_number": "Child protection number",
    "participant.send_password_recovery_email": "Send password recovery email?",
    "notifications.new_log_has_been_added": "New log has been added",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Organisation Name",
    "pageTitle.my_organization_templates": "My Organisation - Templates",
    "pageTitle.award_leaders": "Award Leaders",
    "label.status": "Status",
    "label.street": "Street",
    "roles.if_staff_superuser": "IAF Staff Superuser",
    "table.licence_holder": "Licence Holder",
    "label.created_at": "Created at",
    "table.section": "Section",
    "table.system_rights": "System Rights",
    "label.iac_type": "IAC Type",
    "label.other": "Other",
    "moduleTitle.login": "Login",
    "label.no_data_to_show": "No data to show",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "The Award Level cannot be modified if participants are assigned to the Adventurous Journey",
    "tabs.waiting_payments": "Waiting Payments",
    "global.supervisor": "Supervisor",
    "notifications.new_role_has_been_added": "New role has been added",
    "award.silver_level": "Silver Level",
    "heading.change_awards_mode": "Change Award's mode",
    "button.save_changes": "Save changes",
    "organisation.would_you_like_to_move_award_unit": "Where would you like to remove this organisation?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "My Region Office - Details",
    "table.started_at": "Started at",
    "parentalConsent.i_consent_to_the_award_unit": "2. I consent to the Award Centre and any other individuals, including volunteers*, who are involved in or assist in organising the Award, and hired transportation drivers, transporting the participant for the purpose of participating in activities or functions related to the Award, as required. I understand that the Award Centre will notify me in advance of when and where such travel will occur.",
    "logs.minutes": "minutes",
    "label.total_participants": "Total Participants",
    "moduleTitle.contact_info": "Contact Information",
    "table.payment_link": "Payment link",
    "errors.please_contact_your_local_award_staff": "Please contact your local Award Staff."
}